import { getFullUserName } from "@/common/helpers/get-full-user-name";
import { DEACTIVATED_USER_NAME_CLASS_NAME, isUserDeactivated } from "@/common/helpers/user-deactivated";
import { cn } from "@/common/helpers/utils";
import type { UserItemUser } from "./user-item";

interface UserNameProps {
  user: UserItemUser;
  className?: string;
}

export function UserName({ user, className }: UserNameProps) {
  const isDeactivated = isUserDeactivated(user);

  return (
    <span className={cn("truncate", isDeactivated && DEACTIVATED_USER_NAME_CLASS_NAME, className)}>
      {getFullUserName({ user })}
    </span>
  );
}
